import { useMutation } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import { queryClient } from "../App";

const useUpdateLightSceneOrder = (): any =>
  useMutation({
    mutationFn: async (data: any) => {
      const response = await AXIOS_RESERVATION.put(
        `/updateLightSceneModeList`,
        data
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ["light-scene-list"] });
    },
  });

export default useUpdateLightSceneOrder;
